<kpd-confirm-dialog key="confirmLicenseUserDelete"></kpd-confirm-dialog>
<kpd-secure-action-dialog key="secureDelete"></kpd-secure-action-dialog>
<app-link-entities
  (selectionChanged)="userSelectionChanged($event)"
  [error]="linkUsersError"
  key="linkEntities"
  [cols]="linkUsersCols"
  [searchConfig]="linkUsersSearchConfig"
  [header]="'Link users' | translate"
></app-link-entities>

<div class="detail__grid" *ngIf="isLicenseAvailable()">
  <div class="detail__alert">
    <kpd-alert type="warning" *ngIf="license.isExpired && !readOnlyMode" icon="warning-standard" translate>
      This license is expired and can't be edited
    </kpd-alert>
    <kpd-alert type="warning" *ngIf="license.isUsedup && !readOnlyMode" icon="warning-standard" translate>
      You assigned all your licenses
    </kpd-alert>
    <kpd-alert type="warning" *ngIf="license.isInvalid && !readOnlyMode" icon="warning-standard">
      {{ "This license is tampered with and can't be edited" | translate }}
    </kpd-alert>
    <ng-container *ngIf="saveErrors.length > 0">
      <kpd-alert type="error" *ngFor="let error of saveErrors" icon="warning-standard"> {{ error }} </kpd-alert>
    </ng-container>

    <kpd-hotkey keys="up" (action)="onPrevious()"></kpd-hotkey>
    <kpd-hotkey keys="left" (action)="onPrevious()"></kpd-hotkey>
    <kpd-hotkey keys="down" (action)="onNext()"></kpd-hotkey>
    <kpd-hotkey keys="right" (action)="onNext()"></kpd-hotkey>
    <div class="flex flex-space-between">
      <div class="licenses__summary">
        <span class="license__quantity">
          <clr-icon shape="key"></clr-icon>
          {{ license.quantity }}
        </span>
        <span class="license__count">
          <label class="license__used">{{ license.quantityAssigned }} {{ 'assigned' | translate }}</label>
          <label class="license__remaining">{{ license.quantityAvailable }} {{ 'available' | translate }}</label>
        </span>
      </div>
      <kpd-action-bar *kpdPermission="Permissions.UserLicenseUpdate">
        <kpd-action-create
          (action)="onAdd()"
          *ngIf="!readOnlyMode"
          [disable]="loading || license.quantityAvailable <= 0 || license.isExpired || license.isInvalid"
        >
        </kpd-action-create>
        <kpd-action-delete
          (action)="onDelete()"
          *ngIf="!readOnlyMode"
          [disable]="
            selectedKeys.length === 0 ||
            loading ||
            license.isExpired ||
            (isSystemUserSelected && !hasSystemUserManagePermission)
          "
        >
        </kpd-action-delete>
      </kpd-action-bar>
    </div>
  </div>

  <div class="detail__main">
    <p-table
      dataKey="key"
      [value]="items"
      class="table__fullheight"
      [selectionMode]="readOnlyMode ? null : 'multiple'"
      [scrollable]="true"
      [resizableColumns]="true"
      [columns]="columnsConfig"
      [reorderableColumns]="true"
      [kpdTableRowSelection]="selectedKeys"
      (selectionChanged)="onSelectionChanged($event)"
      kpdDisableTextSelectionOnShiftClick
      kpdTableColumnReorder
      kpdTableSaveColumns="licenseDetailsUsers"
      [metaKeySelection]="true"
      [index]="index"
      kpdTableShiftClick
      kpdTableScroll
    >
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length" translate>No records found</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="colgroup" let-columns>
        <colgroup>
          <col *ngFor="let col of columns" [style.width]="col.width" />
        </colgroup>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" pReorderableColumn pResizableColumn [pSortableColumn]="col.field">
            {{ col.header }}
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
        <tr [pSelectableRow]="rowData" [pSelectableRowIndex]="rowIndex">
          <td *ngFor="let col of columns">
            <ng-container *ngIf="col.type === 'date'">
              {{ rowData[col.field] | localeDateTime }}
            </ng-container>
            <ng-container *ngIf="col.field !== 'upn' && col.type !== 'date'">
              {{ rowData[col.field] }}
            </ng-container>
            <a
              [kpdLinkClick]="rowData.getDetailUrl()"
              (clickEvent)="navigateToUser(rowData.key)"
              *ngIf="col.field === 'upn'"
            >
              {{ rowData[col.field] }}
            </a>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
